<template>
  <div>
    <el-dialog
      title="信息删除确认"
      :visible.sync="dialogVisible"
      append-to-body
      :before-close="handleClose"
      width="30%"
      center=""
    >
      <span class="delete">确定删除这{{ deleteNumber }}条数据吗？</span>
      <span slot="footer">
        <el-button type="primary" @click="handleSure">确认删除</el-button>
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'AnnouncementDeleteDialog',
    data() {
      return {
        dialogVisible: false,
      };
    },
    props: ['deleteNumber'],
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('handleClose');
      },
      handleSure() {
        this.dialogVisible = false;
        this.$emit('handleSure');
      },
    },
  };
</script>

<style scoped>
  .delete {
    margin-left: 140px;
  }
</style>
